// English is the source language: bundled eagerly, used as the fallback, and
// the shape every other locale is type-checked against.
import auth from "./locales/en/auth.json";
import board from "./locales/en/board.json";
import brands from "./locales/en/brands.json";
import catalog from "./locales/en/catalog.json";
import common from "./locales/en/common.json";
import curate from "./locales/en/curate.json";
import explore from "./locales/en/explore.json";
import home from "./locales/en/home.json";
import item from "./locales/en/item.json";
import landing from "./locales/en/landing.json";
import onboarding from "./locales/en/onboarding.json";
import plans from "./locales/en/plans.json";
import settings from "./locales/en/settings.json";
import share from "./locales/en/share.json";
import shell from "./locales/en/shell.json";
import visit from "./locales/en/visit.json";

export const defaultNS = "common";

export const enResources = {
  common,
  auth,
  board,
  brands,
  catalog,
  curate,
  explore,
  home,
  item,
  landing,
  onboarding,
  plans,
  settings,
  share,
  shell,
  visit,
} as const;

export type Namespace = keyof typeof enResources;
export const NAMESPACES = Object.keys(enResources) as Namespace[];
